import PanFeederSP from './Pan-feeder-SP.png';
import PanFeederSP2 from './Pan-feeder-SP_2.png';

export const getImagePanFeeder = () => {
  return PanFeederSP;
};

export const getImagePanFeeder2 = () => {
  return PanFeederSP2;
};
